// localStorage keys
export const SKILLS_REPORT_PRACTICE_SCOPE = 'skillsReportPracticeScope'
export const SKILLS_REPORT_USE_ELL_SKILLS = 'skillsReportUseELLSkills'
export const SKILLS_REPORT_MOMENTUM_SCORE_GOAL = 'skillsReportMomentumScoreGoal'
